export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./~/rmc-feedback/es/index.js
// module id = 369
// module chunks = 125